import { PermissionsEnum, UserOutput } from 'gql/types';

export type PermissionsType = Record<PermissionsEnum, boolean>;

export type CurrentUser = UserOutput & { permissions?: PermissionsType };

export enum PolicyPrivacyContentLang {
  Eng = 'Eng',
}
